export default "/packs/images/DSC05544~7f00c7965bed9f8bb8de2b8b2cd4e785.jpg";